(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Reappliedservices', Reappliedservices);

    Reappliedservices.$inject = ['$resource', 'DateUtils'];

    function Reappliedservices ($resource, DateUtils) {
        var resourceUrl =  'api/reappliedservices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.requireMarkedOnDate = DateUtils.convertDateTimeFromServer(data.requireMarkedOnDate);
                        data.assigOnDate = DateUtils.convertDateTimeFromServer(data.assigOnDate);
                        data.formFilledOnDate = DateUtils.convertDateTimeFromServer(data.formFilledOnDate);
                        data.paymentMadeOnDate = DateUtils.convertDateTimeFromServer(data.paymentMadeOnDate);
                        data.lastactiondate = DateUtils.convertDateTimeFromServer(data.lastactiondate);
                        data.statusdate = DateUtils.convertDateTimeFromServer(data.statusdate);
                        data.integrationDate = DateUtils.convertDateTimeFromServer(data.integrationDate);
                        data.clearedDate = DateUtils.convertDateTimeFromServer(data.clearedDate);
                        data.rejectionDate = DateUtils.convertDateTimeFromServer(data.rejectionDate);
                        data.deemedClearedDate = DateUtils.convertDateTimeFromServer(data.deemedClearedDate);
                        data.reAppliedDate = DateUtils.convertDateTimeFromServer(data.reAppliedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
